// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coustomContactUsBg {
    background-color: #5B7CFD;
    margin-top: 48px;
    height: auto; /* Set default height to "auto" */
  }
  
  @media (min-width: 768px) {
    /* Apply styles for medium-sized screens and above */
    .coustomContactUsBg {
      height: 431px; /* Set the desired height for medium-sized screens and above */
    margin-top: 109px;
    }
  }
  
.markitingImageAligenment{
    margin-top: -17px;
}
.contactUsHeadingMainPage {
  margin-top: 40px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  color: #FFFFFF;
}

@media (max-width: 767px) {
  /* Screens below medium */
  .contactUsHeadingMainPage {
    color: #FFF;
font-size: 32px;
font-family: 'Roboto';
font-style: normal;
font-weight: 700;
line-height: normal;
  }
}


.contactUsPara{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    /* or 156% */
    
    
    color: #FFFFFF;
    
}

.contactUsButtonBox{
    width: 177px;
    height: 56px;
    background-color: white;
    border-radius: 4px;
}

.contactUsButtonText{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #5B7CFD;
    padding-top: 20px;
}

.buttonsRowContactUs {
    margin-top: 30px;
    padding-bottom: 20px;
  }
  .learnButtonButtonBox {
    width: 177px;
    height: 56px;
    border-radius: 4px;
    border: 1px solid white;
  }
  
  .learnButtonCoustomText {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */
  
    text-align: center;
  
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/Inventory/components/ContactUs/ContactUs.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY,EAAE,iCAAiC;EACjD;;EAEA;IACE,oDAAoD;IACpD;MACE,aAAa,EAAE,8DAA8D;IAC/E,iBAAiB;IACjB;EACF;;AAEF;IACI,iBAAiB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB;IACE,WAAW;AACf,eAAe;AACf,qBAAqB;AACrB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;EACjB;AACF;;;AAGA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;;IAGZ,cAAc;;AAElB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,kBAAkB;;IAElB,YAAY;EACd","sourcesContent":[".coustomContactUsBg {\n    background-color: #5B7CFD;\n    margin-top: 48px;\n    height: auto; /* Set default height to \"auto\" */\n  }\n  \n  @media (min-width: 768px) {\n    /* Apply styles for medium-sized screens and above */\n    .coustomContactUsBg {\n      height: 431px; /* Set the desired height for medium-sized screens and above */\n    margin-top: 109px;\n    }\n  }\n  \n.markitingImageAligenment{\n    margin-top: -17px;\n}\n.contactUsHeadingMainPage {\n  margin-top: 40px;\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 60px;\n  color: #FFFFFF;\n}\n\n@media (max-width: 767px) {\n  /* Screens below medium */\n  .contactUsHeadingMainPage {\n    color: #FFF;\nfont-size: 32px;\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\n  }\n}\n\n\n.contactUsPara{\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 25px;\n    /* or 156% */\n    \n    \n    color: #FFFFFF;\n    \n}\n\n.contactUsButtonBox{\n    width: 177px;\n    height: 56px;\n    background-color: white;\n    border-radius: 4px;\n}\n\n.contactUsButtonText{\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    color: #5B7CFD;\n    padding-top: 20px;\n}\n\n.buttonsRowContactUs {\n    margin-top: 30px;\n    padding-bottom: 20px;\n  }\n  .learnButtonButtonBox {\n    width: 177px;\n    height: 56px;\n    border-radius: 4px;\n    border: 1px solid white;\n  }\n  \n  .learnButtonCoustomText {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    /* identical to box height */\n  \n    text-align: center;\n  \n    color: white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
